import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('vip');

// 获取会员信息
export function userinfo() {
  return jrequest('userinfo');
}

// 获得会员产品列表信息
export function products(condition) {
  return jrequest('products', condition);
}

// 会员产品下单
export function buy(condition) {
  return jrequest('buy', condition, { method: 'post', type: 'json' });
}

// 用户会员订单列表
export function orderlist() {
  return jrequest('order/list');
}

// 用户会员订单信息
export function order(orderId) {
  return jrequest('order', { orderId });
}

// 会员专享优惠券
export function coupons() {
  return jrequest('coupons');
}

// 会员优享商品列表
export function goods(conditions) {
  return jrequest('goods', conditions);
}

// 会员秒杀商品列表
export function flashgoods() {
  return jrequest('flash/goods');
}

// 优惠券可使用商品
export function coupongoods(couponId) {
  return jrequest('coupon/goods', { couponId });
}

